module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-31-32-113.2bb695e5.mp4";